var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_716",
    "data-name": "Group 716",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.469,
    height: 153.469,
    viewBox: "0 0 153.469 153.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M76.734,0A76.734,76.734,0,1,1,0,76.734,76.734,76.734,0,0,1,76.734,0Z",
    transform: "translate(0)",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M41.919,58.913A3.565,3.565,0,0,0,40.758,55.9l-8.6-10.357V44h26.7L79.491,89.254,97.632,44h25.449v1.547L115.73,52.6a2.148,2.148,0,0,0-.817,2.063v51.786a2.148,2.148,0,0,0,.817,2.063l7.179,7.048V117.1H86.8v-1.547l7.437-7.22c.731-.73.731-.945.731-2.062V64.414L74.289,116.93H71.5L47.421,64.414v35.2a4.857,4.857,0,0,0,1.333,4.04l9.673,11.732v1.547H31v-1.547l9.673-11.732a4.685,4.685,0,0,0,1.246-4.04Z",
    transform: "translate(-0.306 -1.796)",
    fill: "#273c49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumWhite);
export default __webpack_public_path__ + "static/media/medium-white.61d45bf0e00a10b20c7edcb2b162038a.svg";
export { ForwardRef as ReactComponent };